import React from 'react'

function HomeBox13() {
    return (
        <div className='homebox13'>
            <div className='container homebox12-container'>
                <div className='homebox13-main'>
                    <div className='HomeBox7-top'>
                        <h1>Starting with Loyalific is easy, fast and free</h1>
                        {/* <p>Starting with Loyalific is easy, fast and free</p> */}
                    </div>
                    <a href='https://merchant.loyalific.com/login' className='homebox13-top-btn'>Get started - it's free</a>
                    <p className='homebox13-bottom-text'>Free for 15 days, no credit card required.</p>
                </div>
            </div>
        </div>
    )
}

export default HomeBox13